import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_COLUMN = 'API_GET_LIST_COLUMN';
/**
 * コラム一覧検索
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetListColumn = ({ query: { column_themes: columnThemes, page } }, meta) => apiGetList(API_GET_LIST_COLUMN, '/column', { column_themes: columnThemes, page }, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
